(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comfortzen-experience"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-experience-tour]').forEach(button=>{if(button.dataset.bound)return;button.dataset.bound='true';button.addEventListener('click',()=>{const start=document.querySelector('.cz-tour [data-open]');if(start){start.scrollIntoView({block:'center'});start.click();}})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comfortzen-moments"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('cz-media-carousel')) {
  class ComfortZenCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-go]')];
      if (!this.slides.length) return;
      this.controller = new AbortController();
      this.options = { signal: this.controller.signal };
      this.index = 0;
      this.autoVideo = false;
      this.classList.add('is-enhanced');
      this.visible = true;
      this.hovered = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.running = this.dataset.autoplay === 'true' && !this.motion.matches && !navigator.connection?.saveData && this.slides.length > 1;
      this.delay = Math.max(5, Number(this.dataset.interval) || 6) * 1000;
      this.toggle = this.querySelector('[data-toggle]');
      this.live = this.querySelector('[data-live]');
      this.status = this.querySelector('[data-status]');
      this.toggle?.addEventListener('click', () => {
        this.running = !this.running;
        if (this.running) this.hovered = false;
        else this.slides[this.index]?.querySelector('video')?.pause();
        this.sync();
      }, this.options);
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.move(this.index - 1, true), this.options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.move(this.index + 1, true), this.options);
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.move(Number(dot.dataset.go), true), this.options));
      this.addEventListener('focusin', (event) => {
        if (event.target === this.toggle) return;
        this.stop(event.target.tagName !== 'VIDEO');
      }, this.options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.sync();
      }, this.options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.sync();
      }, this.options);
      this.addEventListener('keydown', (event) => {
        if (event.target.tagName === 'VIDEO' || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.move(target, true);
      }, this.options);
      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.playsInline = true;
        video.addEventListener('ended', () => {
          if (this.canRun() && this.slides[this.index]?.contains(video)) this.move(this.index + 1, false);
        }, this.options);
        video.addEventListener('pointerdown', () => this.stop(false), this.options);
        video.addEventListener('error', () => {
          this.stop(true);
          const error = slide.querySelector('[data-video-error]');
          if (error) error.hidden = false;
        }, this.options);
      });
      document.addEventListener('visibilitychange', () => this.sync(), this.options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.stop(true);
      }, this.options);
      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      const controls = this.querySelector('[data-controls]');
      if (controls) controls.hidden = this.slides.length < 2;
      this.move(0, false);
    }
    canRun() { return this.running && this.visible && !document.hidden && !this.hovered; }
    stop(pauseVideo) {
      this.running = false;
      this.autoVideo = false;
      clearTimeout(this.timer);
      if (pauseVideo) this.slides[this.index]?.querySelector('video')?.pause();
      this.updateControls();
    }
    updateControls() {
      if (this.toggle) {
        this.toggle.setAttribute('aria-label', this.running ? this.dataset.pause : this.dataset.play);
        this.toggle.innerHTML = this.running ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5v14M15 5v14"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 10 7-10 7z"/></svg>';
      }
      this.live.setAttribute('aria-live', this.running ? 'off' : 'polite');
    }
    move(next, manual) {
      clearTimeout(this.timer);
      if (manual) this.running = false;
      this.slides[this.index]?.querySelector('video')?.pause();
      this.autoVideo = false;
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      const video = this.slides[this.index].querySelector('video');
      if (video) { try { video.currentTime = 0; } catch (_) {} }
      this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.live.textContent = `${this.index + 1} / ${this.slides.length}: ${this.slides[this.index].dataset.name}`;
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.updateControls();
      const video = this.slides[this.index]?.querySelector('video');
      if (!this.canRun()) {
        if (video && (!this.visible || document.hidden || this.autoVideo)) video.pause();
        return;
      }
      if (video) {
        this.autoVideo = true;
        video.muted = true;
        if (video.ended) video.currentTime = 0;
        const attempt = video.play();
        attempt?.catch(() => { if (this.slides[this.index]?.contains(video) && this.canRun()) this.stop(false); });
      } else {
        this.timer = setTimeout(() => this.move(this.index + 1, false), this.delay);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.querySelectorAll('video').forEach((video) => video.pause());
      this.initialized = false;
    }
  }
  customElements.define('cz-media-carousel', ComfortZenCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comfortzen-shopping-tour"] && !Shopify.designMode) return;
  try {
    (()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const t=JSON.parse(root.querySelector('[data-strings]').textContent),map=JSON.parse(root.querySelector('[data-map]').textContent),dlg=root.querySelector('dialog'),stage=root.querySelector('[data-stage]'),progress=root.querySelector('[data-progress]'),opener=root.querySelector('[data-open]');Object.keys(t).forEach(k=>{const d=document.createElement('textarea');d.innerHTML=t[k];t[k]=d.value});let page='purchase',kind='',interest='',offer='',history=[];const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));const tr=k=>esc(t[k]);const btn=(k,a,extra='')=>`<button type="button" data-action="${a}" ${extra}>${tr(k)}</button>`;const choice=(k,desc,a)=>`<button type="button" class="cz-choice" data-action="${a}">${tr(k)}${desc?`<small>${tr(desc)}</small>`:''}</button>`;const head=(a,b)=>`<h2 tabindex="-1" data-heading>${tr(a)}</h2><p>${tr(b)}</p>`;const more=c=>`<details><summary>${tr('learn_more')}</summary>${c}</details>`;function go(p){history.push(page);page=p;render()}function render(){let h='',step=1;if(page==='purchase'){h=head('purchase','purchase_sub')+`<div class="cz-grid">${choice('first','','go:welcome')}${choice('returning','','returning')}</div>`}if(page==='welcome'){step=2;h=head('welcome','welcome_text')+`<div class="cz-code">${tr('welcome_code')}</div><p class="cz-tiny">${tr('welcome_detail')}</p><div class="cz-actions">${btn('choose_offer','offer')}${btn('skip_offer','skip','class="cz-secondary"')}</div>`}if(page==='returning'){step=2;h=head('return_head','return_info')+`<span class="cz-tag">${tr('preview')}</span><div class="cz-actions"><a class="cz-link" href="${esc(root.dataset.account)}" target="_blank" rel="noopener">${tr('sign_in')}</a>${btn('explore','go:category')}</div>`+more(`<p>${tr('loyalty_examples')}</p><p>${tr('terms')}</p><p>${tr('ledger')}</p><p><a href="${esc(root.dataset.eligible)}">${tr('eligible_link')}</a></p>`)}if(page==='category'){step=3;h=head('choose','choose_sub')+`<div class="cz-grid">${choice('supplements','supp_desc','kind:supplements')}${choice('massage','massage_desc','kind:massage')}</div>`}if(page==='interest'){step=4;const keys=kind==='massage'?['back_area','neck','feet']:['sleep','immune','focus','sexual','bone','prostate','fitness','energy','relaxation','minerals','botanicals','joint_ingredients'];h=head(kind==='massage'?'area':'interest',kind==='massage'?'area_sub':'interest_sub')+`<div class="cz-grid">${keys.map(k=>choice(k,'','interest:'+k)).join('')}</div>`}if(page==='results'){step=5;h=head('results','results_sub')+`<p class="cz-kicker">${tr(interest)}</p>`;const cards=(map[interest]||[]).map(x=>root.querySelector('template[data-product="'+x+'"]')).filter(Boolean);h+=cards.length?`<div class="cz-grid">${cards.map(x=>x.innerHTML).join('')}</div><p class="cz-tiny">${tr('one_item')}</p>`:`<div class="cz-note"><h3>${tr('no_match')}</h3>${tr('no_match_sub')}</div>`;h+=`<p class="cz-tiny">${tr('label_notice')}</p>`+more(`<p>${tr('no_match_detail')}</p><p>${tr('safety')}</p>`)+`<div class="cz-actions">${btn('choose_another','back','class="cz-secondary"')}${btn('reminder_short','go:reminder','class="cz-secondary"')}</div>`}if(page==='reminder'){step=6;h=head('reminder','reminder_text')+`<label><input type="checkbox" data-optin>${tr('optin')}</label><div data-frequency hidden><label for="cz-interval-${root.id}">${tr('interval')}</label><select id="cz-interval-${root.id}" data-interval><option value="30">${tr('days30')}</option><option value="60">${tr('days60')}</option><option value="90">${tr('days90')}</option></select><p class="cz-tiny">${tr('reminder_note')}</p></div><div class="cz-actions">${btn('demo_save','demo')}${btn('finish','close')}</div><p role="status" data-status></p>`}h+=`${offer?`<p class="cz-note">${tr('offer_selected')}</p>`:''}<div class="cz-nav">${history.length?btn('back','back','class="cz-secondary"'):''}${btn('restart','restart','class="cz-secondary"')}</div><p class="cz-tiny">${tr('privacy')}</p>`;stage.innerHTML=h;progress.textContent=t.progress+' '+step+' '+t.of+' 6';stage.querySelector('[data-heading]')?.focus();dlg.scrollTop=0}function reset(){history=[];offer='';kind='';interest='';page='purchase'}function close(){dlg.close();stage.innerHTML='';reset();opener.focus()}opener.addEventListener('click',()=>{reset();render();dlg.showModal();stage.querySelector('[data-heading]')?.focus()});root.querySelector('[data-close]').addEventListener('click',close);dlg.addEventListener('cancel',e=>{e.preventDefault();close()});stage.addEventListener('change',e=>{if(e.target.matches('[data-optin]'))stage.querySelector('[data-frequency]').hidden=!e.target.checked});stage.addEventListener('click',e=>{const b=e.target.closest('[data-action]');if(!b)return;const a=b.dataset.action;if(a.startsWith('go:'))go(a.split(':')[1]);else if(a.startsWith('kind:')){kind=a.split(':')[1];go('interest')}else if(a.startsWith('interest:')){interest=a.split(':')[1];go('results')}else if(a==='returning'){offer='';go('returning')}else if(a==='offer'){offer='WELCOME10';go('category')}else if(a==='skip'){offer='';go('category')}else if(a==='back'){page=history.pop()||'purchase';render()}else if(a==='restart'){reset();render()}else if(a==='close')close();else if(a==='demo')stage.querySelector('[data-status]').textContent=t[stage.querySelector('[data-optin]').checked?'demo_done':'demo_none'];else if(a==='detail'){const detail=b.closest('.cz-card').querySelector('[data-product-detail]');detail.hidden=!detail.hidden;b.setAttribute('aria-expanded',String(!detail.hidden))}});stage.addEventListener('submit',async e=>{const f=e.target.closest('[data-checkout]');if(!f)return;e.preventDefault();if(f.dataset.busy)return;const id=f.querySelector('[name=id]').value;if(!/^\d+$/.test(id))return;f.dataset.busy='true';const b=f.querySelector('[type=submit]'),status=f.querySelector('[data-cart-status]');b.disabled=true;b.textContent=t.adding;try{const response=await fetch(root.dataset.add,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});if(!response.ok)throw Error('cart');await response.json();status.textContent=t.added;const checkout=new URL(root.dataset.checkout,location.origin);if(offer)checkout.searchParams.set('discount',offer);location.assign(checkout.href)}catch(error){status.textContent=t.failed; b.textContent=t.checkout;}})}document.querySelectorAll('.cz-tour').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.cz-tour').forEach(init))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
